import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
};

const Content = ({ children }) => {
  return <div className="shutterbug-split-layout-content">{children}</div>;
};

Content.propTypes = propTypes;

export default Content;
